// Remove os parâmetros vazios e nulos
export function queryFilter(filters) {
    let params = filters;
    Object.keys(params).forEach((key) => {
        if (params[key] && Array.isArray(params[key])) {
            if (Object.keys(params[key]).length === 0) {
                delete params[key];
            }
        }
        if (
            params[key] &&
            typeof params[key] === "object" &&
            params[key] !== null
        ) {
            if (Object.keys(params[key]).length === 0) {
                delete params[key];
            }
        } else if (
            params[key] === null ||
            params[key] === "" ||
            params[key] === undefined
        )
            delete params[key];
    });

    let query = Object.keys(params)
        .map(
            (param) =>
                `${encodeURIComponent(param)}=${encodeURIComponent(
                    params[param]
                )}`
        )
        .join("&");

    return query ? `?${query}` : "";
}
